// date-fns 2.x has no setDefaultOptions, so the active locale lives here and the
// time helpers read it on every format call. Without it every timestamp in the
// dashboard renders in English regardless of the UI language.
import ptBR from 'date-fns/locale/pt-BR';
import pt from 'date-fns/locale/pt';
import es from 'date-fns/locale/es';

const LOCALES = { pt_BR: ptBR, pt, es };

let activeLocale = null;

export const setDateLocale = locale => {
  activeLocale = LOCALES[locale] || null;
};

// null falls back to date-fns' built-in en-US.
export const dateLocale = () => activeLocale;
